module.exports = __webpack_public_path__ + "img/nav-link-hover.c0cc4d94.svg";